import { memo, type ReactNode } from 'react';

export type HeaderProps = {
  headerLeft?: ReactNode;
  headerRight: ReactNode;
};

export const Header = memo(({ headerLeft, headerRight }: HeaderProps) => {
  return (
    <div className="flex h-12 w-full items-center justify-between gap-4 px-4">
      <div className="flex grow items-center overflow-hidden">{headerLeft}</div>

      {headerRight}
    </div>
  );
});

Header.displayName = 'Header';
